module.exports = __webpack_public_path__ + "img/jamesway_mini_logo.7f42df2c.png";